<div class="modal-header">
  <h4 class="modal-title">Gift PDF Preview</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <img [src]="orgConfig.logo_image"
       alt="logo"
       height="{{ orgConfig.logo_height_px }}"
       style="display: block;margin: auto;margin-top: {{ orgConfig.logo_margin_top_px }}px; margin-bottom: {{ orgConfig.logo_margin_bottom_px }}px;">

  <h4 class="text-center">
    James Anderson has sent you a gift, a $20 Gift Card at {{ accountService.getMyAccount().organization_name }}
  </h4>

  <hr>

  <p>
    Happy birthday, Alex! Hope this year is one for the books and looking forward to many climbing sessions at the gym.
  </p>

  <p>
    Gift Card Code: <b>2UY93QLWHR</b>
  </p>

  <div [innerHtml]="getRenderedMarkdown(orgConfig.gift_card_recipient_text)"></div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Close
  </button>
</div>
